import * as Sentry from '@/core/sentry'
import { http } from '@/utils/api'

export type MaintenanceStatus = {
  maintenanceMode: boolean
}

export async function getMaintenanceStatus() {
  try {
    const { data } = await http.get<MaintenanceStatus>('maintenance')

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    Sentry.captureException(error)

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

const POLL_INTERVAL_MS = 10_000

export async function pollMaintenanceUntilResolvedOrError(
  onIsMaintenance: () => void,
  abortSignal?: AbortSignal
) {
  while (!abortSignal?.aborted) {
    const result = await getMaintenanceStatus()

    if (
      result.status === 'error' ||
      (result.status === 'success' && !result.payload.maintenanceMode)
    ) {
      return result
    }

    onIsMaintenance()

    await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL_MS))
  }

  return {
    status: 'error' as const,
    payload: undefined,
  }
}
